import React from 'react';
import { OpenMenuIcon, CloseMenuIcon, IconContainer, TitleContainer } from './navigation-icon-styles';
import { IconType } from './navigation-icon-types';
var NavigationIcon = function (_a) {
    var title = _a.title, onClick = _a.onClick, iconType = _a.iconType, customOpenMenuIcon = _a.customOpenMenuIcon, customCloseMenuIcon = _a.customCloseMenuIcon;
    return (React.createElement(IconContainer, { onClick: onClick },
        iconType === IconType.OPEN_MENU && (customOpenMenuIcon || React.createElement(OpenMenuIcon, null)),
        iconType === IconType.CLOSE_MENU && (customCloseMenuIcon || React.createElement(CloseMenuIcon, null)),
        !!title && React.createElement(TitleContainer, null, title)));
};
export default NavigationIcon;
export { IconType };
